import React from 'react';
import s from './index.module.scss';
import logo from './img/logo.jpg';
import { getParameterFromURL } from '../../../utils/scripts';

export const Logo = () => {
  const firstScreenAB = getParameterFromURL('fSW') === 'true';
  const tariffURL = getParameterFromURL('tariff');
  const darkTheme = getParameterFromURL('darkTheme') === 'true';

  return (
    <>
      {!tariffURL && firstScreenAB ? (
        <div className={s.wrapperV2}>
          <div className={s.logoV2}></div>
        </div>
      ) : (
        <div className={s.wrapper}>
          <img src={logo} alt="EveryDoggy" />
          <p>EveryDoggy</p>
        </div>
      )}
    </>
  );
};
